import { MIN_YEAR, OFFSCREEN_Y, OFFSCREEN_X, REGIONS} from "../Constants";
import * as d3 from "d3";
import ScatterplotLayout from "./ScatterplotLayout";

class GlobalScatterplotLayout extends ScatterplotLayout {
  constructor(type="global_scatter", nodes, count, model, width, height, offset_x=0, offset_y=0, min_year= MIN_YEAR, key=undefined){
    super(type, nodes, count, model, width, height, offset_x, offset_y, min_year);
    this.coordinates = {};
    this.x_force = d3.forceX( d => { return this._coordinates_x(d.iso)|| OFFSCREEN_X }).strength(0);
		this.y_force = d3.forceY( d => { return this._coordinates_y(d.iso) || OFFSCREEN_Y }).strength(0);
    this.maxSize-=.45;
    this.minSize-=.4;
    this.key = key;
    this.use_hitbox = false;
    this.text = {
      '760' :  `In 2022, five countries – Afghanistan, Egypt, Iraq, Pakistan and Syria – had “very high” levels of both government restrictions and social hostilities involving religion.`,
      '392' : `<strong>Japan</strong> had "low" levels levels of religion-related government restrictions and social hostilities in 2018.`
    };
    this.label_points = {
      '760' : {
        'x' : 5.8,
        'y' : 8.8
      },
      '392' : {
        'x' : 2.8,
        'y' : .8
      }
    };

    for (let i=0; i < this.nodes.length; i++){
      let iso = this.nodes[i].key;
      let gri = this.model.get(iso, "gri", this.year);
      let shi = this.model.get(iso, "shi", this.year);
      let region = REGIONS[this.model.getRegion(iso)];
      if (iso != '408') {
        this.coordinates[iso] = {
          x: this.x_scale(gri),
          y: this.y_scale(shi)
        };
      } else {
        // don't chart North Korea
        this.coordinates[iso] = {
          x: OFFSCREEN_X,
          y: OFFSCREEN_Y
        };
      }
      if (this.use_hitbox) {
        this.axes.appendChild(this.hitBox(iso,gri,shi, region));
      }
    }
    this.tree = d3.quadtree()
      .x(d=> d[1].x)
      .y(d=> d[1].y);

    this.coordinates_ = Object.entries(this.coordinates);
    this.tree.addAll(this.coordinates_);
    this.drawLegend();
    this.drawTooltip();
    this.drawOverlay();
	}

  drawTooltip(){
    const el = document.createElement('div');
    el.setAttribute('class', 'tooltip');
    this.axes.appendChild(el);
  }

  drawOverlay(){
    this.overlay_svg = d3.select(this.labels).append("svg")
      .attr("width", this.width + this.margin.left + this.margin.right)
      .attr("height",this.height + this.margin.top + this.margin.bottom)
      .attr('style', `top:${this.svg_margin.top}px;left:${this.svg_margin.left}px`)
      .append("svg:g")
      .attr("transform", `translate(${this.margin.left},${this.margin.top})`);
      ['760'].forEach( iso => {
        let shi = this.model.get(iso, "shi", this.year);
        let text = this.axes.appendChild(this.makeLabel(iso == '392' ? 2.5 : 0, shi + 1.5, 'index-label global_scatter', this.text[iso]));
        let point1 = {	x: this.coordinates[iso].x - (iso == '392' ? -20 : 20),
                        y: this.coordinates[iso].y - 5
                      };
        let point2 = {	x: this.x_scale(this.label_points[iso].x),
                        y: this.y_scale(this.label_points[iso].y)
                      };
      });
  }

  drawLegend(){
    const d = document.createElement('div');
    d.setAttribute('class', 'legend');
    d.setAttribute('style', `top:${this.svg_margin.top}px;left:${this.svg_margin.left + this.margin.left}px;width:${this.width}px;`);
    let s = document.createElement('span');
    const _d = document.createElement('div');
    _d.setAttribute('class', 'legend-container');
    s.setAttribute('class', 'title');
    s.textContent = `FILTER BY REGION`;
    d.appendChild(s);
    for( const[k,v] of Object.entries(REGIONS)) {
      let d1 = document.createElement('div');
      d1.setAttribute('class', 'region active');
      d1.setAttribute('data-region', v);
      d1.textContent = k;
      _d.appendChild(d1);
    }
    d.appendChild(_d);
    this.axes.appendChild(d);
  }

  layout(animate=false) {
      if (animate) {
        if (typeof this.timer != 'undefined') this.timer.stop();
        this.timer = d3.timer ( elapsed => {
          let t = d3.easeBounceOut(elapsed/1000);
          let scale = this.minSize * ( 1 - t ) + this.maxSize * t;
            for (let i =0; i < this.nodes.length; i++){
              if (typeof this.key == 'undefined') {
                this.nodes[i].values[0].scale.set(scale);
              }
            }

          if (elapsed >= 1000){
            this.timer.stop();
          }
        });
      }
  }

  title() {
    return ``;
  }

  search(x, y, radius, filter) {
    const result = [],
      radius2 = radius * radius,
      accept = filter
        ? d => filter(d) && result.push(d)
        : d => result.push(d);

    this.tree.visit((node, x1, y1, x2, y2) => {
      if (node.length) {
        return x1 >= x + radius || y1 >= y + radius || x2 < x - radius || y2 < y - radius;
      }

      const dx = +this.tree._x.call(null, node.data) - x,
            dy = +this.tree._y.call(null, node.data) - y;
      if (dx * dx + dy * dy < radius2) {
        do { accept(node.data); } while (node = node.next);
      }
    });

    return result;
  }
}

export default GlobalScatterplotLayout;
